import { Input } from 'antd';
import Text from 'antd/lib/typography/Text';
import React, { useEffect } from 'react';
import { Box } from '../../../../components/Box';
import { Option, Select } from '../../../../components/Input';
import { translations } from '../../../../utils/LocalizedStrings';
import { isAddressValid, isNameValid, renderAddress, renderSeparatedAddress } from '../../../../utils/string';
import { countries } from '../../../editor/countries/countries';
import { useFormDataContext } from '../../contexts/form-data.ctx';
import AddressAutoCompleteSeperatedInput from './AddressAutocompleteSeperatedInput';
import { RenderSeparatedName } from '../../../../utils/string';

function SelectKonatel({ documentId, name, tooltip, label = 'Select', ...rest }) {
  const values = useFormDataContext(({ data, setField }) => ({
    konatelia: (
      data.company?.konatelia
    ),
    value: data[name] || { separatedName: {} },
    setField,
  }));

  const [fieldValues, setFieldValues] = React.useState(values);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    if (JSON.stringify(values.value) !== JSON.stringify(fieldValues.values)) {
      let newFieldValues = JSON.parse(JSON.stringify(fieldValues))
      newFieldValues.value = values.value
      setFieldValues(newFieldValues)
    }
  }, [values.value.konatel, values.value.name, values.value.address])


  const handleChange = (value) => {
    if (value !== undefined && !value.target) {
      if (value === "other") {
        fieldValues.value = { konatel: value, separatedName: {}, address: { country: "SK" } }
      } else {
        fieldValues.value = { konatel: value }
      }
      forceUpdate()
    }
    values.setField({
      target: {
        name,
        value: fieldValues.value
      },
    });
  }

  const changeSeparatedName = async (e) => {
    let valuesToSet = fieldValues;
    let separatedName = fieldValues.value.separatedName;
    separatedName[e.target.name] = e.target.value ? e.target.value : e.target.checked;

    setFieldValues(valuesToSet);
    forceUpdate()
  }

  return (
    rest.allowCustomValues ?
      <>
        <Select
          tooltip={tooltip}
          onFocus={rest.onFocus}
          onBlur={rest.onBlur}
          label={label}
          name={name}
          onChange={handleChange}
          placeholder={rest.description}
          value={fieldValues.value.konatel}>
          {fieldValues?.konatelia.map((konatel, index) => {
            return (
              rest.long ?
                <Option value={index} key={`${documentId}_${konatel.personName.formatedName}`}>
                  {konatel.personName.formatedName} - {renderAddress(konatel.address)}
                </Option>
                :
                <Option value={index} key={`${documentId}_${konatel.personName.formatedName}`}>
                  {konatel.personName.formatedName}
                </Option>
            )
          })}
          <Option value={"other"}>
            {rest.long ? translations.artifacts.KonatelBox.otherAdress : translations.artifacts.KonatelBox.otherPerson}
          </Option>
        </Select>
        {fieldValues.value.konatel === 'other' &&
          (rest.long ?
            <AddressAutoCompleteSeperatedInput
              placeholder={translations.artifacts.KonatelBox.selectAdress}
              label={translations.artifacts.KonatelBox.selectAdress}
              id={name}
              name="address"
              onBlur={handleChange}
              onChange={(value) => { fieldValues.value.address = value.value; forceUpdate(); }}
              country={fieldValues.value.address.country}
              number={fieldValues.value.address.number}
              street={fieldValues.value.address.street}
              zip={fieldValues.value.address.zip}
              city={fieldValues.value.address.city}
            />
            :
            <div className="addressAuto">
              <Box flex={1}>
                <Text strong>
                  {translations.artifacts.KonatelBox.enterTitle}
                </Text>
                <Input
                  name="titlesBefore"
                  onBlur={handleChange}
                  placeholder={translations.artifacts.KonatelBox.beforeName}
                  onChange={(e) => changeSeparatedName(e)}
                  value={fieldValues.value.separatedName.titlesBefore ? fieldValues.value.separatedName.titlesBefore : ''}
                />
              </Box>
              <Box flex={1}>
                <Text strong>
                  {translations.artifacts.KonatelBox.enterTitleAfter}
                </Text>
                <Input
                  name="titlesAfter"
                  onBlur={handleChange}
                  placeholder={translations.artifacts.KonatelBox.titleAfter}
                  onChange={(e) => changeSeparatedName(e)}
                  value={fieldValues.value.separatedName.titlesAfter ? fieldValues.value.separatedName.titlesAfter : ''}
                />
              </Box>
              <Box flex={1}>
                <Text strong>
                  {translations.artifacts.KonatelBox.enterName}
                </Text>
                <Input
                  name="name"
                  onBlur={handleChange}
                  placeholder={translations.artifacts.KonatelBox.name}
                  onChange={(e) => changeSeparatedName(e)}
                  value={fieldValues.value.separatedName.name ? fieldValues.value.separatedName.name : ''}
                />
              </Box>
              <Box flex={1}>
                <Text strong>
                  {translations.artifacts.KonatelBox.enterSurname}
                </Text>
                <Input
                  name="surname"
                  onBlur={handleChange}
                  placeholder={translations.artifacts.KonatelBox.surname}
                  onChange={(e) => changeSeparatedName(e)}
                  value={fieldValues.value.separatedName.surname ? fieldValues.value.separatedName.surname : ''}
                />
              </Box>
            </div>
          )
        }
      </>
      :
      <Select
        tooltip={tooltip}
        onFocus={rest.onFocus}
        onBlur={rest.onBlur}
        label={label}
        name={name}
        onChange={handleChange}
        placeholder={rest.description}
        value={fieldValues.value.konatel}>
        {fieldValues?.konatelia?.map((konatel, index) => {
          return (
            rest.long ?
              <Option value={index} key={`${documentId}_${konatel.personName.formatedName}`}>
                {konatel.personName.formatedName} - {renderAddress(konatel.address)}
              </Option>
              :
              <Option value={index} key={`${documentId}_${konatel.personName.formatedName}`}>
                {konatel.personName.formatedName}
              </Option>
          )
        })}
      </Select>
  );
}

function SelectKonatelRenderer(id, values, long) {
  if (values[id] !== undefined) {
    if (values[id].konatel !== undefined) {
      if (values[id].konatel === 'other') {
        return long ? renderSeparatedAddress(values[id].address) : RenderSeparatedName(values[id].separatedName)
      }
      if (Number.isInteger(values[id].konatel)) {
        let konatelia = values.company?.konatelia
        return long ?
          renderAddress(konatelia[values[id].konatel].address) :
          konatelia[values[id].konatel].personName.formatedName
      }
    }
  }
}

function Validator(id, values, long) {
  if (values[id] !== undefined) {
    if (values[id].konatel !== undefined) {
      if (values[id].konatel === "other") {
        return long ? isAddressValid(values[id].address) : isNameValid(values[id].separatedName)
      }
      return Number.isInteger(values[id].konatel)
    }
  }
  return false
}

export default {
  Mutator: SelectKonatel,
  HTMLRenderer: SelectKonatelRenderer,
  Validator: Validator
};
